import { useCallback, useMemo, useState } from 'react';

import { GradientButton } from './button/GradientButton';
import { SecondaryButton } from './button/SecondaryButton';
import { Modal } from './modal/Modal';
import { TimeScopePicker } from './time-scope-picker/TimeScopePicker';
import { TimeScope } from './time-scope-picker/types';
import { adjustScopeForConstraints, getDefaultTimeScopeValues } from './time-scope-picker/utils';
import { t } from '../services/translation/translation';
import { parseDate } from '../utils/date';

type Props = {
  onClose: () => void;
  onSave: (_timestamp?: number) => void;
};

export const DatePickerModal = ({ onClose, onSave }: Props) => {
  const minDate = useMemo(() => Date.now(), []);

  const [scope, setScope] = useState<TimeScope>(adjustScopeForConstraints(getDefaultTimeScopeValues(), minDate));

  const handleChange = useCallback((scope?: TimeScope) => {
    if (scope) {
      setScope(scope);
    }
  }, []);

  const handleSave = () => {
    onSave(parseDate(`${scope.year}-${scope.month + 1}-${scope.day}`, 'YYYY-M-D').valueOf());
    onClose();
  };

  return (
    <Modal onClose={onClose}>
      <Modal.Header onClose={onClose} title={t('common.expiry-date')} />
      <Modal.Body>
        <p className="text-gray-500 dark:text-gray-400">{t('vehicle-route.badge-description')}</p>
        <div className="flex items-center justify-center">
          <TimeScopePicker mode="day" onScopeChange={handleChange} scope={scope} minDate={minDate} hideActions />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <GradientButton onClick={handleSave}>{t('common.save')}</GradientButton>
        <SecondaryButton onClick={onClose}>{t('common.cancel')}</SecondaryButton>
      </Modal.Footer>
    </Modal>
  );
};
